import { type TransitionEvent, useState } from "react";
import { Drawer, useDrawer } from "../../../../elements";
import { SearchIcon } from "../../../../icons";
import { useNavbar } from "../../hooks";
import styles from "./navbar-search-mobile.module.css";

export const NAVBAR_SEARCH_MOBILE = "NAVBAR_SEARCH_MOBILE";

export function NavbarSearchMobile() {
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);
  const { open, close, isOpen } = useDrawer();
  const { renderAutocomplete, searchRightSlot } = useNavbar();

  const isDrawerOpen = isOpen(NAVBAR_SEARCH_MOBILE);

  const handleTransitionEnd = (e: TransitionEvent<HTMLDivElement>) => {
    if (!(e.target instanceof HTMLDivElement)) {
      return;
    }

    if (e.target?.dataset?.name === NAVBAR_SEARCH_MOBILE) {
      setIsSearchOpen(isDrawerOpen);
    }
  };

  function handleClose() {
    close(NAVBAR_SEARCH_MOBILE);
  }

  return (
    <div className={styles.Container}>
      <button
        type="button"
        onClick={() => open(NAVBAR_SEARCH_MOBILE)}
        className={styles.Button}
      >
        <SearchIcon viewBox="0 0 24 24" size={24} />
      </button>
      {searchRightSlot?.({
        isDesktop: false,
        isMobile: true,
        isTablet: false,
      })}

      <Drawer onTransitionEnd={handleTransitionEnd} name={NAVBAR_SEARCH_MOBILE}>
        {isDrawerOpen &&
          renderAutocomplete?.({
            isMobile: true,
            onClose: handleClose,
            isOpen: isSearchOpen,
          })}
      </Drawer>
    </div>
  );
}
